<template>
  <v-footer app color="primary lighten-1" class="pa-0" dark>
    <v-row justify="center" no-gutters>
      <v-col class="primary py-3 text-center" cols="12">
        &copy; {{ copyrightText }}
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: 'MainHeader',
  props: {
    copyrightText: String,
  },
};
</script>

<style scoped>
.main-title {
  cursor: pointer;
  font-family: 'Noto Serif JP', serif;
  font-weight: bold;
}
</style>
